export default __webpack_public_path__ + "static/media/cakers-share.861e6e70.png";